"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectStatusApi = void 0;
const HTTP_METHOD_1 = require("../../../constants/HTTP_METHOD");
/**
 * @description Project Statuses API
 */
class ProjectStatusApi {
    constructor(_connector, _verifyResponses) {
        this._connector = _connector;
        this._verifyResponses = _verifyResponses;
    }
    /**
     * @description
     * Get an index of projects
     */
    index(
    // query: ProjectStatusQuery = {}
    ) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this._connector.apiFetchWithAuth('/project/status', HTTP_METHOD_1.HTTP_METHOD.GET);
            return result;
        });
    }
}
exports.ProjectStatusApi = ProjectStatusApi;
